import { useCallback } from 'react';
import { useChannel } from './useChannel.js';

/**
 * @param channelName Channel to use
 * @param eventName Name of event to bind to
 * @returns IUseEvent values to bind/unbind to event
 * @example
 * ```javascript
 * const { eventBind, eventUnbind } = useEvent('channel-name', 'event-name');
 * eventBind(callback);
 * eventUnbind(callback); // it will remove the callback handler from 'channel-name' event
 * eventUnbind(); // it will remove all callbacks attached to 'channel-name' event
 * ```
 * Important: if we don't pass the callback function to unbind, all handlers attached to
 * that event will be removed.
 */

function useEvent(channelName, eventName) {
  const {
    channel
  } = useChannel(channelName);
  const eventBind = useCallback(callback => {
    channel === null || channel === void 0 ? void 0 : channel.bind(eventName, callback);
  }, [channel, eventName]);
  const eventUnbind = useCallback(callback => {
    channel === null || channel === void 0 ? void 0 : channel.unbind(eventName, callback);
  }, [channel, eventName]);
  return {
    eventBind,
    eventUnbind
  };
}

export { useEvent };
//# sourceMappingURL=useEvent.js.map
